

















































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Contact } from '@/api/model/contact'

@Component
export default class EditContactSpouseForm extends Vue {
    @Prop() readonly value!: Contact
    selectedTab: string = 'basic'

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    get validGenders() {
        return Contact.validGenders.map(value => ({ label: this.$t(`gender.${value}`), value }))
    }
}
